import React from "react";
import styles from "./LegalInfo.module.css";

const LegalInfo = () => {
    return (
        <div className={styles.infoBlocks}>
            <div className={styles.block}>
                <div className={styles.item}>
                    <p className={styles.title}>Юридический адрес:</p>
                    <p>123122, г. Москва, Пресненская набережная, д.12, <br/> пом. 15Н/29</p>
                </div>
                <div className={styles.item}>
                    <p className={styles.title}>Полное наименование: </p>
                    <p>Общество с ограниченной ответственностью<br /> «Сайбертех»</p>
                </div>
                <div className={styles.item}>
                    <p className={styles.title}>Сокращенное наименование: </p>
                    <p>ООО «Сайбертех»</p>
                </div>
            </div>
            <div className={styles.block}>
                <div className={styles.item}>
                    <p className={styles.title}>Почтовый адрес:</p>
                    <p>123122, г. Москва, Пресненская набережная, д.12, пом. 15Н/29</p>
                </div>
                <div className={styles.item}>
                    <p className={styles.title}>ИНН/КПП:</p>
                    <p>9703155452/770301001</p>
                </div>
                <div className={styles.item}></div>
            </div>
            
        </div>
    );
};

export default LegalInfo;


